import React, { Component, Fragment } from "react";
import utils from "../../../../utils/utils";
import { Link } from "react-router-dom";
import PercentualEvasao from "../../../UI/PercentualEvasao";
import swal from 'sweetalert';


export default class Metas extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            aplicationName: "Módulo de Metas",
            metas: [],
            total: [],
            modalidade: "Todas"
        }
        
    }

    verificaCor = (fonte) => {
        if(fonte === "SIGEM") return { backgroundColor: "#faebd7" }
        else return;
    }

    calculaHoraAlunoDistribuidaPercentualEvasao = (curso) => {
        let valores = curso?.metasMensais?.horaAlunoDistribuidaPercentualEvasao || [];

        return valores.reduce((acc, atual) => acc + (Number(atual) || 0), 0);
    }

    calculaTotalHoraAlunoDistribuidaPercentualEvasao = () => {
        return (this.props.metas || []).reduce((acc, curso) => acc + this.calculaHoraAlunoDistribuidaPercentualEvasao(curso), 0);
    }

    excluirSweetAlert = (id) => {
        swal({
            title: "Tem certeza?",
            text: "Esta ação não pode ser desfeita!",
            icon: "warning",
            buttons: ["Cancelar", "OK"],
            dangerMode: true,
          })
        .then((willDelete) => {
            if (willDelete) {
                this.props.excluirMeta(id)
            } 
        });
    }

    render() {
        return (
            <Fragment>

                <div className="row pr-3 pl-3">
                    <div className="col-md-12 ml-auto mr-auto">
                        <div className="card card-user">
                            <div className="card-header">
                                <div className="row row-tabela">
                                    <div className="col-md-12">

                                        <table border="1" className="gap table table-striped table-bordered table-hover table-sm table-responsive-lg no-space-bottom">
                                            <thead>
                                                <tr>
                                                    <th>CURSOS</th>
                                                    <th>N.° de Turmas</th>
                                                    <th>N.º de Alunos Turmas</th>
                                                    <th>Carga Horária</th>
                                                    <th>Mat. Residuais</th>
                                                    <th>Mat. Novas</th>
                                                    <th>Total Mat.</th>
                                                    <th>Hora/aluno</th>
                                                    <th>Hora/aluno Distribuida</th>
                                                    <th>Hora/aluno Distribuida c/ evasão</th>
                                                    {/* <th>Carga H. Turma/Ano</th>
                                                    <th>Necessidade de docente (8h)</th>
                                                    <th>Necessidade de docente (7,2h)</th> */}
                                                    <th>Ação</th>
                                                </tr>
                                            </thead>
                                            <tbody id="metasCursos">
                                                {(this.props.metas || []).map((curso, key) => {
                                                    return (
                                                        <tr key={`==${curso.codigo}==${curso._id}==`} style={this.verificaCor(curso.fonte)}>
                                                            <td className="tooltipp text-dark">{curso.curso} <span className="tooltiptext">&#9673; {curso.modalidade} <br/>&#9673; {curso.turno} <br/>&#9673; {curso.tipo}</span></td>
                                                            <td>{utils.formataValor(curso.metasMensais.total[0])}</td>
                                                            <td>{utils.formataValor(curso.metasMensais.total[1])}</td>
                                                            <td>{utils.formataValor(curso.metasMensais.total[2])}</td>
                                                            <td>{utils.formataValor(curso.metasMensais.total[3])}</td>
                                                            <td>{utils.formataValor(curso.metasMensais.total[4])}</td>
                                                            <td>{utils.formataValor(curso.metasMensais.total[5])}</td>
                                                            <td>{utils.formataValor(curso.metasMensais.total[6])}</td>
                                                            {/* <td>{utils.formataValor(curso.metasMensais.total[7])}</td>
                                                            <td>{utils.formataValor(curso.metasMensais.total[8])}</td>
                                                            <td>{utils.formataValor(curso.metasMensais.total[9])}</td> */}
                                                            <td>{utils.formataValor(curso.metasMensais.total[10])}</td>
                                                            <td>{utils.formataValor(this.calculaHoraAlunoDistribuidaPercentualEvasao(curso))}</td>
                                                            <td>
                                                                <div className="block-acao">
                                                                    <span><a href={`/unidade/${this.props.unidade === "citi/cam" ? "cam" : this.props.unidade}/mensais-${curso._id}`} className="btn btn-link btn-warning edit"><i className="fa fa-edit"></i></a></span>
                                                                    {/*
                                                                    <span>
                                                                        <Link to={location => ({ ...location, pathname: `/unidade/${this.props.unidade}/mensais-${curso._id}`, curso: curso})}>
                                                                            <button className="btn btn-link btn-warning edit"><i className="fa fa-edit"></i></button>
                                                                        </Link>
                                                                    </span>
                                                                    */}
                                                                    <span><a className="btn btn-link btn-danger remove" onClick={() => this.excluirSweetAlert(curso._id)}><i className="fa fa-times"></i></a></span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}

                                                <tr className="table-secondary total_curso">
                                                    <td>TOTAL</td>
                                                    {(this.props.total || []).map((total, key) => {
                                                        if([7, 8, 9].includes(key)) return
                                                        return (
                                                            <Fragment>
                                                                <td key={"chave" + key}>{total.toLocaleString("pt-BR", { maximumFractionDigits: 2 , style: 'decimal' })}</td>
                                                            </Fragment>
                                                        )
                                                    })} 
                                                    <td>{this.calculaHoraAlunoDistribuidaPercentualEvasao({ metasMensais: { horaAlunoDistribuidaPercentualEvasao: (this.props.metas || []).map((curso) => this.calculaHoraAlunoDistribuidaPercentualEvasao(curso)) } }).toLocaleString("pt-BR", { maximumFractionDigits: 2 , style: 'decimal' })}</td>
                                                    <td></td>
                                                </tr>

                                            </tbody>
                                        </table>

                                        <p>
                                            <strong>Hora/aluno Distribuída com Percentual de Evasão:</strong> <span style={{ fontSize: "20px" }}>{utils.formataValor(this.calculaTotalHoraAlunoDistribuidaPercentualEvasao())}</span>
                                            <span title="Calculado aplicando o percentual de evasão por modalidade sobre cada valor de 'Hora/aluno Distribuída' e somando os meses." style={{ marginLeft: 8, cursor: 'help' }}> ⓘ</span>
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}